<template>
  <v-dialog
    :value="visible"
    max-width="340"
    content-class="lafia-inapp-dialog"
    overlay-color="#25191c"
    :overlay-opacity="0.68"
    @input="handleVisibility"
  >
    <section class="royal-card" role="dialog" aria-modal="true" aria-labelledby="inapp-dialog-title" :lang="languageCode">
      <button type="button" class="royal-close" :aria-label="$t('button.close')" @click="confirmClick">
        <span aria-hidden="true">×</span>
      </button>
      <div class="royal-card__inner">
        <div class="royal-emblem" aria-hidden="true">
          <img src="@/assets/deco/inapp-royal-emblem-transparent.png" alt="" class="royal-emblem__castle" />
        </div>

        <div class="royal-wordmark" aria-hidden="true">
          <span></span>
          <b>THE LAFIA KINGDOM</b>
          <span></span>
        </div>

        <template v-if="!showGuide">
          <p class="royal-kicker">{{ $t("dialog.inweb-kicker") }}</p>
          <h2 id="inapp-dialog-title" class="royal-title">{{ $t("dialog.inweb-title") }}</h2>
          <p class="royal-note">{{ $t("dialog.inweb-note") }}</p>

          <button v-if="android" type="button" class="royal-primary" @click="openChrome">
            {{ $t("dialog.inweb-chrome-open") }}
          </button>
          <button type="button" :class="android ? 'royal-secondary' : 'royal-primary'" @click="openGuide">
            {{ $t("dialog.inweb-open-guide") }}
          </button>
          <button type="button" class="royal-secondary" @click="confirmClick">
            {{ $t("dialog.inweb-dismiss") }}
          </button>
        </template>

        <template v-else>
          <div class="royal-guide-visual" role="img" :aria-label="$t('dialog.inweb-guide')">
            <div class="royal-guide-panel royal-guide-panel--menu" aria-hidden="true">
              <div class="royal-browser-bar">
                <span class="royal-browser-address"></span>
                <span class="royal-browser-menu">⋮</span>
              </div>
              <div class="royal-browser-sheet">
                <span></span>
                <span></span>
                <span></span>
                <strong>{{ guideLabels.externalBrowser }}</strong>
              </div>
            </div>

            <div class="royal-guide-panel royal-guide-panel--apps" aria-hidden="true">
              <b>{{ guideLabels.openWith }}</b>
              <div class="royal-app-choice royal-app-choice--active">
                <span class="royal-chrome-icon"></span>
                <strong>Chrome</strong>
              </div>
              <div class="royal-app-choice">
                <span class="royal-browser-icon"></span>
                <span>{{ guideLabels.otherBrowser }}</span>
              </div>
            </div>
          </div>
          <p class="royal-guide">{{ $t("dialog.inweb-guide") }}</p>

          <button type="button" class="royal-primary" @click="confirmClick">
            {{ $t("dialog.inweb-guide-close") }}
          </button>
          <button type="button" class="royal-secondary" @click="showGuide = false">
            {{ $t("dialog.inweb-guide-back") }}
          </button>
        </template>
      </div>
    </section>
  </v-dialog>
</template>
<script>
import { androidChromeIntentUrl, handoffUrl, isAndroid, trackInApp } from "@/util/externalBrowser"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showGuide: false,
    android: isAndroid(),
  }),

  computed: {
    languageCode() {
      return this.$i18n.locale === "jp" ? "ja" : this.$i18n.locale
    },

    guideLabels() {
      if (this.$i18n.locale === "jp") {
        return {
          externalBrowser: "外部ブラウザで開く",
          openWith: "アプリで開く",
          otherBrowser: "別のブラウザ",
        }
      }

      if (this.$i18n.locale === "en") {
        return {
          externalBrowser: "Open in external browser",
          openWith: "Open with",
          otherBrowser: "Other browser",
        }
      }

      return {
        externalBrowser: "외부 브라우저로 열기",
        openWith: "다음 앱으로 열기",
        otherBrowser: "다른 브라우저",
      }
    },
  },

  watch: {
    visible(value) {
      if (!value) this.showGuide = false
      if (value) trackInApp("dialog_shown", { platform: this.android ? "android" : "other" })
    },
  },

  methods: {
    handleVisibility(value) {
      this.$emit("input", value)
    },

    confirmClick() {
      if (!this.showGuide) trackInApp("dialog_dismiss")
      this.showGuide = false
      this.$emit("confirm")
    },

    openGuide() {
      trackInApp("dialog_guide")
      this.showGuide = true
    },

    // 크롬을 바로 연다. 예약 선택·언어를 주소에 실어 크롬에서 그대로 이어진다. 크롬이 없으면 같은 주소가 기본 브라우저로 열린다.
    openChrome() {
      trackInApp("open_chrome", { platform: "android" })
      window.location.href = androidChromeIntentUrl(handoffUrl(this.$store.state.lang))
      window.setTimeout(() => {
        if (!document.hidden) this.showGuide = true
      }, 1500)
    },
  },
}
</script>
<style scoped>
::v-deep .lafia-inapp-dialog {
  margin: 12px;
  overflow: visible;
  box-shadow: none;
}

.royal-card {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 36px);
  overflow: visible;
  padding: 7px;
  color: #493a35;
  background: #fffaf1;
  border: 1px solid #d4ad68;
  border-radius: 25px;
  box-shadow:
    0 24px 58px rgba(31, 19, 20, 0.34),
    0 4px 12px rgba(31, 19, 20, 0.18);
  isolation: isolate;
}

.royal-close {
  position: absolute;
  z-index: 5;
  top: 14px;
  right: 14px;
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #745f55;
  background: rgba(255, 250, 241, 0.94);
  border: 1px solid rgba(178, 132, 65, 0.72);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(55, 36, 31, 0.14);
  cursor: pointer;
}

.royal-close span {
  display: block;
  margin-top: -2px;
  font-family: Arial, sans-serif;
  font-size: 25px;
  font-weight: 300;
  line-height: 1;
}

.royal-close:focus-visible {
  outline: 3px solid rgba(184, 85, 105, 0.32);
  outline-offset: 3px;
}

.royal-card__inner {
  position: relative;
  z-index: 2;
  padding: 22px 20px 18px;
  text-align: center;
  background: #fffaf3;
  border: 1px solid rgba(194, 144, 66, 0.82);
  border-radius: 18px;
}

.royal-card__inner > * {
  position: relative;
  z-index: 2;
}

.royal-emblem {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 104px;
  margin-top: 2px;
}

.royal-emblem__castle {
  display: block;
  width: 154px;
  max-width: 62%;
  height: auto;
  mix-blend-mode: multiply;
}

.royal-wordmark {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0 auto 20px;
  color: #a77a39;
}

.royal-wordmark span {
  width: 28px;
  height: 1px;
  background: #d2aa68;
}

.royal-wordmark b {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  white-space: nowrap;
}

.royal-kicker {
  margin: 0 0 12px;
  color: #a34054;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  font-size: clamp(24px, 7vw, 29px);
  line-height: 1.25;
  word-break: keep-all;
}

.royal-title {
  margin: 0;
  color: #3f342f;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  font-size: clamp(22px, 6vw, 26px);
  font-weight: 400;
  line-height: 1.35;
  word-break: keep-all;
}

.royal-guide-visual {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
  margin: 0 0 10px;
}

.royal-guide-panel {
  min-width: 0;
  height: 136px;
  overflow: hidden;
  text-align: left;
  background: #f7f5f2;
  border: 1px solid rgba(160, 126, 100, 0.34);
  border-radius: 9px;
  box-shadow: 0 4px 10px rgba(65, 50, 44, 0.1);
}

.royal-browser-bar {
  display: flex;
  height: 29px;
  align-items: center;
  gap: 7px;
  padding: 0 7px;
  background: #fff;
  border-bottom: 1px solid #ddd7d2;
}

.royal-browser-address {
  flex: 1;
  height: 8px;
  background: #ece9e6;
  border-radius: 999px;
}

.royal-browser-menu {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  color: #3c3836;
  border: 2px solid #bd4961;
  border-radius: 50%;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

.royal-browser-sheet {
  display: grid;
  gap: 8px;
  padding: 12px 9px 9px;
  background: #fff;
}

.royal-browser-sheet span {
  display: block;
  width: 70%;
  height: 5px;
  background: #d8d4d1;
  border-radius: 999px;
}

.royal-browser-sheet strong {
  display: flex;
  min-height: 28px;
  align-items: center;
  padding: 4px 6px;
  color: #38312e;
  border: 2px solid #bd4961;
  border-radius: 7px;
  font-size: 9px;
  line-height: 1.25;
}

.royal-guide-panel--apps {
  padding: 10px 8px;
  background: #fff;
}

.royal-guide-panel--apps > b {
  display: block;
  margin: 0 0 8px;
  color: #3e3734;
  font-size: 10px;
  line-height: 1.3;
}

.royal-app-choice {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 7px;
  padding: 5px 6px;
  color: #5f5651;
  border-bottom: 1px solid #e5e0dc;
  font-size: 9px;
  line-height: 1.2;
}

.royal-app-choice--active {
  margin-bottom: 3px;
  color: #362f2c;
  border: 2px solid #bd4961;
  border-radius: 7px;
}

.royal-chrome-icon,
.royal-browser-icon {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.royal-chrome-icon {
  position: relative;
  background: conic-gradient(#e7443a 0 33%, #f1c53c 33% 66%, #43a865 66% 100%);
}

.royal-chrome-icon::after {
  content: "";
  position: absolute;
  inset: 6px;
  background: #4285f4;
  border: 2px solid #fff;
  border-radius: 50%;
}

.royal-browser-icon {
  background: linear-gradient(145deg, #76a8ff, #5c62d8);
}

.royal-note,
.royal-guide {
  margin: 14px 0 19px;
  color: #645652;
  font-family: "NanumSquare", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  word-break: keep-all;
}

.royal-guide {
  min-height: 0;
  margin: 0 3px 16px;
  font-size: 12px;
  line-height: 1.5;
}

.royal-primary,
.royal-secondary {
  width: 100%;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  cursor: pointer;
}

.royal-primary {
  min-height: 50px;
  padding: 11px 14px;
  color: #fffdf8;
  background: #b85569;
  border: 2px solid #c9945b;
  border-radius: 10px;
  box-shadow:
    inset 0 0 0 2px rgba(255, 236, 196, 0.42),
    0 8px 16px rgba(117, 42, 59, 0.2);
  font-size: 18px;
  line-height: 1.25;
}

.royal-primary:focus-visible,
.royal-secondary:focus-visible {
  outline: 3px solid rgba(184, 85, 105, 0.32);
  outline-offset: 3px;
}

.royal-secondary {
  min-height: 46px;
  margin-top: 10px;
  padding: 10px 14px;
  color: #594b46;
  background: #fffdf8;
  border: 1px solid rgba(198, 153, 78, 0.72);
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(72, 51, 44, 0.07);
  font-size: 17px;
  line-height: 1.25;
}

[lang="ja"] .royal-kicker,
[lang="ja"] .royal-title,
[lang="ja"] .royal-primary,
[lang="ja"] .royal-secondary {
  font-family: "GN-Kin-iro_SansSerif", "NanumSquare", sans-serif;
}

@media (max-width: 420px) {
  .royal-card {
    padding: 7px;
    border-radius: 23px;
  }

  .royal-card__inner {
    padding: 20px 18px 16px;
    border-radius: 18px;
  }

  .royal-close {
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
  }

  .royal-emblem {
    height: 96px;
    margin-top: 0;
  }

  .royal-emblem__castle {
    width: 144px;
  }

  .royal-wordmark {
    gap: 8px;
    margin-bottom: 17px;
  }

  .royal-wordmark span {
    width: 22px;
  }

  .royal-wordmark b {
    font-size: 11px;
    letter-spacing: 0.14em;
  }

  .royal-kicker {
    margin-bottom: 11px;
  }

  .royal-note {
    margin: 13px 0 18px;
    font-size: 13px;
  }

  .royal-guide-visual {
    gap: 8px;
  }

  .royal-guide-panel {
    height: 128px;
  }

  .royal-guide {
    margin-bottom: 14px;
    font-size: 11px;
  }

  .royal-primary {
    min-height: 48px;
    font-size: 17px;
  }

  .royal-secondary {
    min-height: 44px;
    margin-top: 9px;
    font-size: 16px;
  }
}

.royal-note {
  white-space: pre-line;
}

@media (max-height: 680px) {
  .royal-card__inner {
    padding-top: 16px;
  }

  .royal-emblem {
    height: 84px;
    margin-top: 0;
  }

  .royal-emblem__castle {
    width: 132px;
  }

  .royal-wordmark {
    margin-bottom: 16px;
  }
}
</style>
